<div [hidden]="!ViewReady">
    <h1 class="mat-h1">IRIS Data Dashboard</h1>
    <div>
        The following data display(s) provide more detailed information about past and present IRIS requests for the current fiscal
        year. This information is valid as of <strong>{{ LastUpdated | date: 'M/d/yyyy h:mm aa' }}</strong
        >. (You may refresh the page to get a more recent update, if desired.)
    </div>
    <br />
    <div>
        Future IRIS System updates will enhance this with additional data displays as requested. Have an idea for a new data display?
        Email <a href="mailto:webapps@polk-fl.net">webapps@polk-fl.net</a> and we will be happy to try and add the requested display!
    </div>
    <!-- #region Requests by Priority Table -->
    <h2 class="margin-top mat-h2">Requests By Priority</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
        <div class="mat-elevation-z10 margin-center" fxFlex="60" fxFlex.lt-md="100">
            <table class="mat-table fullwidth">
                <thead>
                    <tr class="mat-header-row">
                        <th class="mat-header-cell centered">Priority</th>
                        <th class="mat-header-cell centered">Cancelled</th>
                        <th class="mat-header-cell centered">Unanswered</th>
                        <th class="mat-header-cell centered">Pending Time</th>
                        <th class="mat-header-cell centered">Responded / Not Finalized</th>
                        <th class="mat-header-cell centered">Completed</th>
                        <th class="mat-header-cell centered">Job Time (hrs)</th>
                        <th class="mat-header-cell centered">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="mat-row">
                        <td class="mat-cell centered">Urgent</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.UrgentCancelledCount || 0 }} ({{
                                BoardStatistics?.UrgentCancelledPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.UrgentUnanswered || 0 }} ({{
                                BoardStatistics?.UrgentUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.UrgentPendingCount || 0 }} ({{
                                BoardStatistics?.UrgentPendingPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.UrgentAnswered || 0 }} ({{
                                BoardStatistics?.UrgentAnsweredPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.UrgentComplete || 0 }} ({{
                                BoardStatistics?.UrgentCompletePercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">{{ BoardStatistics?.UrgentJobTime || 0 | number: '1.1' }}</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.UrgentCount || 0 }} ({{ BoardStatistics?.UrgentPercent || 0 | number: '1.1' }}%)
                        </td>
                    </tr>
                    <tr class="mat-row">
                        <td class="mat-cell centered">High</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.HighCancelledCount || 0 }} ({{
                                BoardStatistics?.HighCancelledPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.HighUnanswered || 0 }} ({{
                                BoardStatistics?.HighUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.HighPendingCount || 0 }} ({{
                                BoardStatistics?.HighPendingPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.HighAnswered || 0 }} ({{ BoardStatistics?.HighAnsweredPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.HighComplete || 0 }} ({{ BoardStatistics?.HighCompletePercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">{{ BoardStatistics?.HighJobTime || 0 | number: '1.1' }}</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.HighCount || 0 }} ({{ BoardStatistics?.HighPercent || 0 | number: '1.1' }}%)
                        </td>
                    </tr>
                    <tr class="mat-row">
                        <td class="mat-cell centered">Routine</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.RoutineCancelledCount || 0 }} ({{
                                BoardStatistics?.RoutineCancelledPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.RoutineUnanswered || 0 }} ({{
                                BoardStatistics?.RoutineUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.RoutinePendingCount || 0 }} ({{
                                BoardStatistics?.RoutinePendingPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.RoutineAnswered || 0 }} ({{
                                BoardStatistics?.RoutineAnsweredPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.RoutineComplete || 0 }} ({{
                                BoardStatistics?.RoutineCompletePercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">{{ BoardStatistics?.RoutineJobTime || 0 | number: '1.1' }}</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.RoutineCount || 0 }} ({{ BoardStatistics?.RoutinePercent || 0 | number: '1.1' }}%)
                        </td>
                    </tr>
                    <tr class="mat-row">
                        <td class="mat-cell centered">Low</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.LowCancelledCount || 0 }} ({{
                                BoardStatistics?.LowCancelledPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.LowUnanswered || 0 }} ({{
                                BoardStatistics?.LowUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.LowPendingCount || 0 }} ({{
                                BoardStatistics?.LowPendingPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.LowAnswered || 0 }} ({{ BoardStatistics?.LowAnsweredPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.LowComplete || 0 }} ({{ BoardStatistics?.LowCompletePercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">{{ BoardStatistics?.LowJobTime || 0 | number: '1.1' }}</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.LowCount || 0 }} ({{ BoardStatistics?.LowPercent || 0 | number: '1.1' }}%)
                        </td>
                    </tr>
                    <tr class="mat-row">
                        <td class="mat-cell centered">Cancelled (No Priority)</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.CancelledNoPriorityCount || 0 }} ({{
                                BoardStatistics?.CancelledNoPriorityPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.CancelledNoPriorityCount || 0 }} ({{
                                BoardStatistics?.CancelledNoPriorityPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                    </tr>
                    <tr class="mat-row">
                        <td class="mat-cell centered">Closed as Non-Info</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">N/A</td>
                        <td class="mat-cell centered">
                            {{ BoardStatistics?.ClosedNonInfoCount || 0 }} ({{
                                BoardStatistics?.ClosedNonInfoPercent || 0 | number: '1.1'
                            }}%)
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="mat-footer-row">
                        <th clas="mat-footer-cell">Totals</th>
                        <th clas="mat-footer-cell">
                            {{ BoardStatistics?.CancelledCount || 0 }} ({{ BoardStatistics?.CancelledPercent || 0 | number: '1.1' }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardStatistics?.AllUnanswered || 0 }} ({{
                                BoardStatistics?.AllUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardStatistics?.PendingTimeCount || 0 }} ({{
                                BoardStatistics?.PendingTimePercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardStatistics?.AllAnswered || 0 }} ({{ BoardStatistics?.AllAnsweredPercent || 0 | number: '1.1' }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardStatistics?.AllComplete || 0 }} ({{ BoardStatistics?.AllCompletePercent || 0 | number: '1.1' }}%)
                        </th>
                        <th clas="mat-footer-cell">{{ BoardStatistics?.AllJobTime || 0 | number: '1.1' }}</th>
                        <th clas="mat-footer-cell">{{ BoardStatistics?.TotalCount || 0 }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div [hidden]="!PrioritiesChart" fxFlex="40" fxFlex.lt-md="100">
            <canvas id="prioritiesCanvas"> {{ PrioritiesChart }}</canvas>
        </div>
    </div>

    <!-- #endregion -->
    <!-- #region Requests by Board Member Table -->
    <h2 class="margin-top mat-h2">Requests By Board Member</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
        <div [hidden]="!BoardMembersChart" fxFlex="40" fxFlex.lt-md="100" fxFlexOrder.lt-md="2">
            <canvas id="boardmembersCanvas">{{ BoardMembersChart }}</canvas>
        </div>
        <div class="mat-elevation-z10 margin-center" fxFlex="60" fxFlex.lt-md="100" fxFlexOrder.lt-md="1">
            <table class="mat-table fullwidth">
                <thead>
                    <tr class="mat-header-row">
                        <th class="mat-header-cell centered">Board Member</th>
                        <th class="mat-header-cell centered">Cancelled</th>
                        <th class="mat-header-cell centered">Closed Non-Info</th>
                        <th class="mat-header-cell centered">Unassigned</th>
                        <th class="mat-header-cell centered">Unanswered</th>
                        <th class="mat-header-cell centered">Responded / Not Finalized</th>
                        <th class="mat-header-cell centered">Completed</th>
                        <th class="mat-header-cell centered">Job Time (hrs)</th>
                        <th class="mat-header-cell centered">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="mat-row" *ngFor="let board of BoardMembersSummary">
                        <td class="mat-cell centered">{{ board?.FirstName | titleCase }} {{ board?.LastName | titleCase }}</td>
                        <td class="mat-cell centered">
                            {{ board?.CancelledCount || 0 }} ({{ board?.CancelledPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ board?.ClosedNonInfoCount || 0 }} ({{ board?.ClosedNonInfoPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ board?.AllUnassigned || 0 }} ({{ board?.AllUnassignedPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ board?.AllUnanswered || 0 }} ({{ board?.AllUnansweredPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ board?.AllAnswered || 0 }} ({{ board?.AllAnsweredPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ board?.AllComplete || 0 }} ({{ board?.AllCompletePercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">{{ board?.AllJobTime || 0 | number: '1.1' }}</td>
                        <td class="mat-cell centered">
                            {{ board?.TotalCount || 0 }} ({{ board?.TotalPercent || 0 | number: '1.1' }}%)
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="mat-footer-row">
                        <th clas="mat-footer-cell">Totals</th>
                        <th clas="mat-footer-cell">
                            {{ BoardMembersTotals?.CancelledCount || 0 }} ({{
                                BoardMembersTotals?.CancelledPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardMembersTotals?.ClosedNonInfoCount || 0 }} ({{
                                BoardMembersTotals?.ClosedNonInfoPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardMembersTotals?.AllUnassigned || 0 }} ({{
                                BoardMembersTotals?.AllUnassignedPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardMembersTotals?.AllUnanswered || 0 }} ({{
                                BoardMembersTotals?.AllUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardMembersTotals?.AllAnswered || 0 }} ({{
                                BoardMembersTotals?.AllAnsweredPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ BoardMembersTotals?.AllComplete || 0 }} ({{
                                BoardMembersTotals?.AllCompletePercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">{{ BoardMembersTotals?.AllJobTime || 0 | number: '1.1' }}</th>
                        <th clas="mat-footer-cell">{{ BoardMembersTotals?.TotalCount || 0 }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <!-- #endregion -->
    <!-- #region Requests by Category Table -->
    <h2 class="margin-top mat-h2">Requests By Category</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
        <div class="mat-elevation-z10 margin-center" fxFlex="60" fxFlex.lt-md="100">
            <table class="mat-table fullwidth">
                <thead>
                    <tr class="mat-header-row">
                        <th class="mat-header-cell centered">Category</th>
                        <th class="mat-header-cell centered">Cancelled</th>
                        <th class="mat-header-cell centered">Closed Non-Info</th>
                        <th class="mat-header-cell centered">Unassigned</th>
                        <th class="mat-header-cell centered">Unanswered</th>
                        <th class="mat-header-cell centered">Responded / Not Finalized</th>
                        <th class="mat-header-cell centered">Completed</th>
                        <th class="mat-header-cell centered">Job Time (hrs)</th>
                        <th class="mat-header-cell centered">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="mat-row" *ngFor="let cat of CategoriesSummary">
                        <td class="mat-cell centered">{{ cat?.CategoryDescription }}</td>
                        <td class="mat-cell centered">
                            {{ cat?.CancelledCount || 0 }} ({{ cat?.CancelledPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ cat?.ClosedNonInfoCount || 0 }} ({{ cat?.ClosedNonInfoPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ cat?.AllUnassigned || 0 }} ({{ cat?.AllUnassignedPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ cat?.AllUnanswered || 0 }} ({{ cat?.AllUnansweredPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ cat?.AllAnswered || 0 }} ({{ cat?.AllAnsweredPercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">
                            {{ cat?.AllComplete || 0 }} ({{ cat?.AllCompletePercent || 0 | number: '1.1' }}%)
                        </td>
                        <td class="mat-cell centered">{{ cat?.AllJobTime || 0 | number: '1.1' }}</td>
                        <td class="mat-cell centered">{{ cat?.TotalCount || 0 }} ({{ cat?.TotalPercent || 0 | number: '1.1' }}%)</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="mat-footer-row">
                        <th clas="mat-footer-cell">Totals</th>
                        <th clas="mat-footer-cell">
                            {{ CategoriesTotals?.CancelledCount || 0 }} ({{
                                CategoriesTotals?.CancelledPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ CategoriesTotals?.ClosedNonInfoCount || 0 }} ({{
                                CategoriesTotals?.ClosedNonInfoPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ CategoriesTotals?.AllUnassigned || 0 }} ({{
                                CategoriesTotals?.AllUnassignedPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ CategoriesTotals?.AllUnanswered || 0 }} ({{
                                CategoriesTotals?.AllUnansweredPercent || 0 | number: '1.1'
                            }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ CategoriesTotals?.AllAnswered || 0 }} ({{ CategoriesTotals?.AllAnsweredPercent || 0 | number: '1.1' }}%)
                        </th>
                        <th clas="mat-footer-cell">
                            {{ CategoriesTotals?.AllComplete || 0 }} ({{ CategoriesTotals?.AllCompletePercent || 0 | number: '1.1' }}%)
                        </th>
                        <th clas="mat-footer-cell">{{ CategoriesTotals?.AllJobTime || 0 | number: '1.1' }}</th>
                        <th clas="mat-footer-cell">{{ CategoriesTotals?.TotalCount || 0 }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div [hidden]="!CategoriesChart" fxFlex="40" fxFlex.lt-md="100">
            <canvas id="categoriesCanvas">{{ CategoriesChart }}</canvas>
        </div>
    </div>
    <!-- #endregion -->
</div>
